import { createBillingCheckout, getBillingMe } from '@/lib/api';
import { toast } from 'sonner';

/**
 * Initiates a Stripe checkout for the user's next plan.
 * - Trial users (no premium yet): $1 / 7 days
 * - Renewal users (premium expired or active): $7 / 30 days
 *
 * Caller can override `plan` to force one of "trial" | "renewal".
 */
export async function startUpgrade(plan = null) {
  try {
    let chosenPlan = plan;
    if (!chosenPlan) {
      const { data } = await getBillingMe();
      chosenPlan = data?.next_plan || 'trial';
    }
    const origin = window.location.origin;
    const res = await createBillingCheckout(chosenPlan, origin);
    if (res?.data?.url) {
      window.location.href = res.data.url;
      return true;
    }
    toast.error('Could not start checkout — try again');
  } catch (err) {
    const msg = err?.response?.data?.detail || 'Could not start checkout';
    toast.error(msg);
  }
  return false;
}
